<script>
    // import Route, {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import transfers from "../stores/transfers";
    import R, {LOADER} from "../lib/requests";
    import {
        USER_ROLE,
        ROUTE_TYPE,
        ROUTE_TYPES,
        LOCATION_TYPE,
        CUSTOMER_TYPE,
        CUSTOMER_TYPES,
        TRANSFER_STATUSES,
        TRANSFER_STATUS, PAYMENT_TYPE, TRANSFERS_SOURCE
    } from "../lib/constants";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObject, formatDate, getDate, setFocusTo, getIdFromUrl} from "../lib/lib";
    import A from "../lib/Router/A.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import TransferRoute from "./TransferRoute.svelte";
    import TransferVehicles from "./TransferVehicles.svelte";
    import TransferCommissions from "./TransferCommissions.svelte";
    import TimeControl from "../components/controls/TimeControl.svelte";
    import NumberSpinner from "../components/controls/NumberSpinner.svelte";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";

    import DateControl from "../components/controls/DateControl.svelte";
    import TransferReservation from "./TransferReservation.svelte";
    import SendMailPopup from "./SendMailPopup.svelte";

    export let transferId = null;
    export let returnTrip = false;

    let breadcrumb = [
        {id: 'transfers', name: 'Transfers', link: `/app/transfers`}
    ];

    let transfer = null;
    let initData = {};
    let defaultLocations = [];
    let hotels = [];

    let account = null;
    let transferUser = null;

    let users = [];
    let departments = [];
    let pickup = null;
    let drop = null;
    let transferDate = null;
    let transferTime = null;
    let commissions = [];
    let statuses = [];
    let maxPassengers = 0;
    let totalPassengers = 0;
    let customerTypes = [];
    let flightLabel = null;
    let pageTitle = "";

    let showNotificationPopup = false;

    const initialize = () => {

        const onSuccess = result => {
            initData = result;

            if (transferId == 0) {
                setTransferData();
            } else {
                load();
            }
        }

        const onFailure = err => {
        };

        R.handle(R.transfer.initialize, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const setTransferData = () => {
        if (transferId == 0) {
            transfer = {
                id: 0,
                group_id: 0,
                user_id: $user.id,
                department_id: 0,
                // hotel_id: 0,
                account_id: 0, //initData.accounts[0].id,
                tour_id: 0,
                customer_id: 0,
                customer: {
                    // hotel_id: 0,
                    fullname: '',
                    phone: '',
                    email: '',
                    room_no: '',
                },

                customer_type: 0,
                payment_type: 0,

                route_type: ROUTE_TYPE.ARRIVAL,
                pickup_id: initData.locations[0].id,
                pickup_name: '',
                pickup_address: '',
                drop_id: null,
                drop_name: '',
                drop_address: '',

                vehicles: [{
                    vehicle_type_id: $app.vehicle_types[0].id,
                    vehicle: null,
                    driver: null,
                    transporter_id: 0,
                }],
                adults: 1,
                children: 0,
                infants: 0,
                booster_seats: 0,
                baby_seats: 0,
                infant_seats: 0,
                luggage: 0,

                transfer_at: getDate(),
                status_id: 0,
                commissions: [],
            }
        }

        account = initData.accounts.find(x => x.id == transfer.account_id);
        transferDate = formatDate(transfer.transfer_at, 'y-m-d');
        transferTime = formatDate(transfer.transfer_at, 'H:i');
        transfer.customer_type = parseInt(transfer.customer_type);
        transfer.payment_type = parseInt(transfer.payment_type);
        transfer.status_id = parseInt(transfer.status_id);
        commissions = transfer.commissions;

        if (transfer.id == 0) {
            pickup = initData.locations[0];
        } else {
            pickup = transfer.pickup;
            drop = transfer.drop;
            delete (transfer.pickup);
            delete (transfer.drop);
        }

        if (returnTrip) {
            pageTitle = "New Transfer";
            transferId = 0;
            transfer.group_id = transfer.id;

            transfer.group_transfer = {
                id: transfer.id,
                route_type: transfer.route_type,
                transfer_at: transfer.transfer_at,
            }
            transfer.id = 0;

            let temp = pickup;
            pickup = drop;
            drop = temp;
            transfer.route_type = transfer.route_type == ROUTE_TYPE.ARRIVAL ? ROUTE_TYPE.DEPARTURE : transfer.route_type;
            transfer.status_id = TRANSFER_STATUS.OPEN;
            transferDate = getDate();
            transferTime = null;
            transfer.flight_no = '';
            transfer.notes = '';
            transfer.driver_notes = '';
            // commissions = [];
            transfer.vehicles.map(item => {
                item.transporter_id = 0;
                item.transporter_name = "";
                item.vehicle = null;
                item.driver = null;
            });
        } else {
            pageTitle = transfer.id > 0 ? `Transfer ${transfer.code}` : "New Transfer";
        }

        if (transfer.group_transfer) {
            transfer.group_transfer.transfer_at = formatDate(transfer.group_transfer.transfer_at, 'd-m-y H:i');
        }

        initDepartments();
        initUsers();
        if (transfer.department_id > 0) {
            onDepartmentChange();
        }
    }

    const load = () => {
        const onSuccess = result => {
            transfer = result;
            pageTitle = "Transfer " + transfer.code;
            if (transfer.user) {
                transferUser = transfer.user;
                delete (transfer.user);
            }
            setTransferData();
        }

        const onFailure = err => {
            transferId = -1;
        };

        R.handle(R.transfer.details, transferId, onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {

        const onSuccess = result => {
            transfer.id = result.id;
            Notifier.showMessage("Transfer saved");
            $transfers.changed = true;
        }

        const onFailure = err => {
        };

        if (transfer.payment_type == PAYMENT_TYPE.ON_ACCOUNT && transfer.account_id == 0) {
            Alert.warning("No account", 'Payment type is "On Account" but there is no account related to transfer!');
            return;
        }

        if (!pickup) {
            Notifier.showError("Select pickup location!");
            return;
        }

        if (!drop) {
            Notifier.showError("Select destination!");
            return;
        }

        if (!transferDate) {
            Notifier.showError("Transfer date not specified!");
            setFocusTo("transferDate");
            return;
        }

        if (!transferTime) {
            Notifier.showError("Transfer time not specified!");
            setFocusTo("transferTime");
            return;
        }

        if (totalPassengers > maxPassengers) {
            Notifier.showError("Too many passengers!\nConsider adding more vehicles");
            return;
        }

        transfer.customer.fullname = transfer.customer.fullname.trim();
        if (!transfer.customer.fullname) {
            Notifier.showError("Enter customer name!");
            setFocusTo("customerName");
            return;
        }

        transfer.transfer_at = `${transferDate} ${transferTime}`;

        transfer.pickup_id = pickup.id;
        transfer.pickup_name = pickup.name;
        transfer.pickup_address = pickup.address;

        transfer.drop_id = drop.id;
        transfer.drop_name = drop.name;
        transfer.drop_address = drop.address;

        if (transfer.route_type == ROUTE_TYPE.TRANSFER) {
            transfer.flight_no = '';
        }

        let totalCommissions = 0;
        transfer.commissions = [];
        commissions.map(item => {
            transfer.commissions.push({
                object_type: item.object_type,
                object_id: item.object_id,
                vehicle_id: item.vehicle_id,
                price: item.price,
                is_custom: item.is_custom
            });
            totalCommissions += parseFloat(item.price);
        });
        if (totalCommissions > transfer.price) {
            Alert.warning("Commissions", "Commissions are greater than the transfer price!");
            return;
        }

        let action = transfer.id === 0 ? 'create' : 'edit';
        R.handle(R.transfer[action], transfer, onSuccess, onFailure, LOADER.POPUP);
    }

    const initDepartments = () => {
        if (user.isAdmin()) {
            departments = copyObject(initData.departments);
            departments = [{id: 0, name: "select department"}, ...departments];
        } else {
            departments = initData.departments.filter(x => x.users.indexOf($user.id) > -1);
            if (!transfer.department_id) {
                transfer.department_id = departments[0].id;
                onDepartmentChange();
            }
        }
    }

    const initUsers = (department) => {
        users = [];

        if (!user.isAdmin()) {
            // User is a department user
            users = [{id: $user.id, name: $user.name}];
            return;
        }

        if (!department) {
            department = initData.departments.find(x => x.id == transfer.department_id);
        }
        if (department) {
            // set department users
            department.users.map(user_id => {
                let user = initData.users.find(x => x.id == user_id);
                if (user) {
                    users = [...users, user];
                }
            });
        }

        // add original transfer user in department users
        if (transferUser && !users.filter(x => x.id == transferUser.id).length) {
            users = [transferUser, ...users];
        }

        // add current user in department users in not exist
        if (!users.filter(x => x.id == $user.id).length) {
            users = [{id: $user.id, name: $user.name}, ...users];
        }
    }

    const onDepartmentChange = () => {
        hotels = [];

        // add start points in default locations
        defaultLocations = initData.locations.filter(x => x.is_start_point == 1);

        let department = initData.departments.find(x => x.id == transfer.department_id);
        if (department) {
            // find department account
            account = initData.accounts.find(x => x.id == department.account_id);
            transfer.account_id = department.account_id;

            // add department hotels in default locations
            department.hotels.map(id => {
                let location = initData.locations.find(x => x.hotel_id == id);
                if (location) {
                    defaultLocations = [...defaultLocations, location];
                }

                let hotel = initData.hotels.find(x => x.id == id);
                if (hotel) {
                    hotels = [...hotels, hotel];
                }
            });
        } else {
            transfer.account_id = 0;
            transfer.department_id = 0;
            account = null;
        }

        initUsers(department);
    }

    const addVehicleType = () => {
        transfer.vehicles = [...transfer.vehicles, {
            vehicle_type_id: $app.vehicle_types[0].id,
            transporter_id: 0,
            vehicle: null,
            driver: null,
        }];
    }

    const removeVehicleType = (index) => {
        transfer.vehicles.splice(index, 1);
        transfer.vehicles = transfer.vehicles;
    }


    Object.keys(CUSTOMER_TYPE).map(key => {
        customerTypes.push({
            id: CUSTOMER_TYPE[key],
            name: CUSTOMER_TYPES[CUSTOMER_TYPE[key]]
        });
    });

    Object.keys(TRANSFER_STATUS).map(key => {
        statuses.push({
            id: TRANSFER_STATUS[key],
            name: TRANSFER_STATUSES[TRANSFER_STATUS[key]]
        });
    });


    // console.log("getIdFromUrl", getIdFromUrl('departure'));
    // let id = getIdFromUrl('departure');
    // if (id) {
    //     transferId = id;
    //     returnTrip = true;
    // }


    initialize();

    $: {
        if (transfer) {
            maxPassengers = 0;
            transfer.vehicles.map(vehicle => {
                let item = $app.vehicle_types.find(x => x.id == vehicle.vehicle_type_id);
                if (item) {
                    maxPassengers += parseInt(item.max_pax);
                }
            });
            totalPassengers = parseInt(transfer.adults) + parseInt(transfer.children) + parseInt(transfer.infants);

            flightLabel = null;
            if (transfer.route_type == ROUTE_TYPE.ARRIVAL && pickup) {
                if (pickup.type_id == LOCATION_TYPE.AIRPORT) {
                    flightLabel = "Arrival Flight No";
                } else if (pickup.type_id == LOCATION_TYPE.PORT) {
                    flightLabel = "Arrival Boat Name";
                }
            } else if (transfer.route_type == ROUTE_TYPE.DEPARTURE && drop) {
                if (drop.type_id == LOCATION_TYPE.AIRPORT) {
                    flightLabel = "Departure Flight No";
                } else if (drop.type_id == LOCATION_TYPE.PORT) {
                    flightLabel = "Departure Boat Name";
                }
            }
        }
    }
</script>
<!--{#if $transfers.list != null}-->
<Breadcrumb {breadcrumb}/>
<!--{/if}-->
<PageHeader title="{ pageTitle }"/>
{#if transfer}
    <div class="transfer">
        <div class="row">
            <div class="col-xl-5 col-lg-7">
                <div class="panel border-default mb-5">
                    <div class="panel-body panel-pad">
                        {#if account}
                            <h5>{ account.name }</h5>
                        {:else}
                            <!--                            <h5>{ $app.settings.company_name }</h5>-->
                            <h5>No Account!</h5>
                        {/if}
                        {#if user.isAdmin()}
                            <div class="row mb-4">
                                <div class="col-xl-6 form-group">
                                    <label>Department</label>
                                    <select class="form-select" bind:value="{ transfer.department_id }"
                                            on:change={ onDepartmentChange }>
                                        {#each departments as item}
                                            <option value="{ item.id }">{ item.name }</option>
                                        {/each}
                                    </select>
                                </div>
                                <div class="col-xl-6 form-group">
                                    <label>User</label>
                                    {#if users.length}
                                        <select class="form-select" bind:value="{ transfer.user_id }">
                                            {#each users as item}
                                                <option value="{ item.id }">{ item.name }</option>
                                            {/each}
                                        </select>
                                    {:else}
                                        {#if transfer.department_id > 0}
                                            <div class="form-control text-light">department has no users!</div>
                                        {:else}
                                            <div class="form-control text-light">select department first</div>
                                        {/if}
                                    {/if}
                                </div>
                            </div>
                        {:else}
                            <div class="form-group">
                                <label>Department</label>
                                <select class="form-select" bind:value="{ transfer.department_id }"
                                        on:change={ onDepartmentChange }>
                                    {#each departments as item}
                                        <option value="{ item.id }">{ item.name }</option>
                                    {/each}
                                </select>
                            </div>
                        {/if}

                        <div class="mb-5">
                            <TransferRoute bind:routeType={transfer.route_type} bind:pickup={pickup}
                                           bind:drop={drop} {defaultLocations}
                                           disableSwitch={ returnTrip || transfer.id > 0 }/>
                            <div class="row">
                                <div class="col form-group">
                                    <label>Date</label>
                                    <DateControl id="transferDate" bind:value="{ transferDate }"/>
                                    <!--                                    <input type="date" class="form-control" id="transferDate" bind:value="{ transferDate }">-->
                                </div>
                                <div class="col form-group">
                                    <label>Time</label>
                                    <TimeControl id="transferTime" bind:time="{ transferTime }"/>
                                </div>
                            </div>
                            {#if transfer.group_transfer}
                                { ROUTE_TYPES[transfer.group_transfer.route_type] }:
                                <a href="/app/transfer/{ transfer.group_transfer.id }" target="_blank" class="is-link"
                                   title="open transfer on new tab">
                                    { transfer.group_transfer.transfer_at }
                                </a>
                            {/if}
                        </div>

                        <legend>
                            <h6 class="mb-0">Vehicle</h6>
                            <button class="btn btn-primary btn-xs btn-flex" on:click="{ addVehicleType }">
                                <AppIcon icon="plus-circle" size="16" strokeWidth="2" left/>
                                add vehicle
                            </button>
                        </legend>
                        <div class="mb-5">
                            {#each transfer.vehicles as item, index}
                                <div class="input-group" class:mb-1={ transfer.vehicles.length > 1}>
                                    <select class="form-select"
                                            bind:value="{ transfer.vehicles[index].vehicle_type_id }">
                                        {#each $app.vehicle_types as item}
                                            <option value="{ item.id }">{ item.name } ({ item.description })</option>
                                        {/each}
                                    </select>
                                    {#if index > 0}
                                        <button class="btn btn-default" title="remove vehicle"
                                                on:click="{ () => removeVehicleType(index) }">
                                            <AppIcon icon="x" size="16"/>
                                        </button>
                                    {/if}
                                </div>
                            {/each}
                        </div>

                        <legend>
                            <h6 class="mb-0">Passengers</h6>
                            {#if maxPassengers > 0}
                                <div class="fw-semibold">{ totalPassengers } / { maxPassengers }</div>
                            {/if}
                        </legend>
                        <div class="row">
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Adults</label>
                                <NumberSpinner bind:value="{ transfer.adults }"/>
                            </div>
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Children</label>
                                <NumberSpinner bind:value="{ transfer.children }"/>
                            </div>
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Infants</label>
                                <NumberSpinner bind:value="{ transfer.infants }"/>
                            </div>
                        </div>

                        {#if transfer.children > 0 || transfer.infants > 0}
                            <hr class="hidden-xl hidden-lg hidden-md">
                            <div class="row">
                                <div class="col-md-4 col-sm-12 form-group">
                                    <label>Boosters</label>
                                    <NumberSpinner bind:value="{ transfer.booster_seats }"/>
                                </div>
                                <div class="col-md-4 col-sm-12 form-group">
                                    <label>Baby seats</label>
                                    <NumberSpinner bind:value="{ transfer.baby_seats }"/>
                                </div>
                                <div class="col-md-4 col-sm-12 form-group">
                                    <label>Infant seats</label>
                                    <NumberSpinner bind:value="{ transfer.infant_seats }"/>
                                </div>
                            </div>
                        {/if}

                        <div class="row">
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Luggage</label>
                                <NumberSpinner bind:value="{ transfer.luggage }"/>
                            </div>
                        </div>

                        {#if maxPassengers > 0 && totalPassengers > maxPassengers}
                            <div class="alert alert-danger p-2 mb-0">
                                Too many passengers... consider adding more vehicles
                            </div>
                        {/if}
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-lg-5">
                <div class="panel border-default mb-5">
                    <div class="panel-body panel-pad">
                        <div class="form-group">
                            <h5>Customer</h5>
                            <select class="form-select" bind:value="{ transfer.customer_type }">
                                {#each customerTypes as item}
                                    <option value="{ item.id }">{ item.name }</option>
                                {/each}
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" id="customerName"
                                   bind:value="{ transfer.customer.fullname }">
                        </div>
                        <div class="form-group">
                            <label>Phone</label>
                            <input type="tel" class="form-control" bind:value="{ transfer.customer.phone }">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" bind:value="{ transfer.customer.email }">
                        </div>
                        <div class="form-group">
                            <label>Room No</label>
                            <input type="text" class="form-control width-50" bind:value="{ transfer.customer.room_no }">
                        </div>
                        {#if flightLabel}
                            <div class="form-group">
                                <label>{ flightLabel }</label>
                                <input type="text" class="form-control" bind:value="{ transfer.flight_no }">
                            </div>
                        {/if}
                        <div>
                            <label>Notes</label>
                            <textarea class="form-control" bind:value="{ transfer.notes }"
                                      placeholder="notes"></textarea>
                            {#if transfer.reservation}
                                <p class="small mb-0">
                                    Warning: notes can be visible to customer!
                                </p>
                            {/if}
                        </div>
                        {#if transfer.notified_at != null}
                            <div class="text-success-emphasis mt-2">
                                Client notified about this transfer at {formatDate(transfer.notified_at, 'd-m-y')}.
                            </div>
                        {/if}
                        {#if user.isAdmin()}
                            <button class="btn btn-link px-0" on:click={() => showNotificationPopup = true}>
                                Send mail to client
                            </button>
                        {/if}
                    </div>
                </div>

                {#if user.isAdmin() && transfer.reservation}
                    <TransferReservation {transfer} reservation={transfer.reservation}/>
                {/if}
            </div>
            <div class="col-xl-4 col-lg-12">
                {#if user.isAdmin()}
                    <TransferVehicles bind:vehicles={ transfer.vehicles } bind:notes={ transfer.driver_notes }
                                      transferId="{ transfer.id }" {transferDate}/>
                {/if}
                {#if $user.role == USER_ROLE.GOD}
                    <div class="col-xl-12">
                        <TransferCommissions accounts="{initData.accounts}" departments="{initData.departments}"
                                             {transfer}
                                             bind:commissions={commissions}/>
                    </div>
                {:else if user.isDepartmentAdmin()}
                    <div class="panel panel-default mb-5">
                        <div class="panel-heading">Pricing</div>
                        <div class="panel-body panel-pad">
                            <div class="form-group">
                                <label>Cost</label>
                                <div class="commission-price">
                                    <PriceControl bind:value="{ transfer.price }" placeholder="€"/>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
                <div class="panel panel-default mb-5">
                    <div class="panel-heading">Status</div>
                    <div class="panel-body panel-pad">
                        <select class="form-select" bind:value="{ transfer.status_id }">
                            {#each statuses as status}
                                <option value="{ status.id }">{ status.name }</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel border-default mb-4">
            <div class="panel-body panel-pad">
                <div class="row">
                    <div class="col-xl-8">
                        {#if transfer.created_at}
                            <div>
                                Created: <span class="text-gray">{ formatDate(transfer.created_at, 'd-m-y H:i') }</span>
                            </div>
                        {/if}
                        {#if transfer.updated_at}
                            <div>
                                Updated: <span class="text-gray">{ formatDate(transfer.updated_at, 'd-m-y H:i') }</span>
                            </div>
                        {/if}
                    </div>

                    <div class="col-xl-4 text-end">
                        {#if transfer.id > 0 && transfer.group_id == 0 && transfer.route_type == ROUTE_TYPE.ARRIVAL}
                            <A href="/app/departure/{ transfer.id }" class="btn btn-danger btn-lg me-2">
                                CREATE DEPARTURE
                            </A>
                        {/if}
                        <button class="btn btn-primary btn-lg px-5" on:click="{ save }">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}

{#if showNotificationPopup}
    <SendMailPopup bind:transfer onClose={() => showNotificationPopup = false}/>
{/if}

{#if transferId == -1}
    <PageNotFound message="Transfer not found!"/>
{/if}